(() => {
  const catalogFamilies = new Map([
    ['/collections/af', 'compressed-air-filters'],
    ['/collections/compressed-air-filters', 'compressed-air-filters'],
    ['/collections/ac-air-pressure-regulator', 'air-pressure-regulators'],
    ['/collections/air-pressure-regulators', 'air-pressure-regulators'],
    ['/collections/aw-air-filter-regulator-combo-piggyback', 'filter-regulators'],
    ['/collections/filter-regulators', 'filter-regulators'],
    ['/collections/ac-three', 'two-stage-filter-regulator-units'],
    ['/collections/two-stage-filter-regulator-units', 'two-stage-filter-regulator-units'],
    ['/collections/ac-compressed-air-filter-regulator-lubricator-combo', 'frl-combination-units'],
    ['/collections/frl-combination-units', 'frl-combination-units'],
    ['/collections/ac-frl', 'three-piece-frl-units'],
    ['/collections/three-piece-frl-units', 'three-piece-frl-units'],
  ]);

  const parseUrl = (value) => {
    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  };

  const familyFromUrl = (value) => {
    const url = parseUrl(value);
    if (!url) return '';
    return url.searchParams.get('az_type') || catalogFamilies.get(url.pathname.replace(/\/$/, '')) || '';
  };

  const catalogUrl = (family) => `/collections/all?az_type=${encodeURIComponent(family)}`;

  const sizeFromSearchUrl = (value) => {
    const url = parseUrl(value);
    if (!url || url.pathname.replace(/\/$/, '') !== '/search') return '';

    const query = (url.searchParams.get('q') || '')
      .trim()
      .toLowerCase()
      .replace(/[“”]/g, '"')
      .replace(/\s+/g, ' ');
    const match = query.match(/^(\d)\s*\/\s*(\d)\s*(?:"|in|inch)?\s*npt$/);
    if (match) return `${match[1]}-${match[2]}`;
    return /^1\s*(?:"|in|inch)?\s*npt$/.test(query) ? '1' : '';
  };

  const rewriteProductSelectionLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const family = familyFromUrl(link.href);
      const url = parseUrl(link.href);
      if (!url) return;

      const size = sizeFromSearchUrl(link.href);
      if (size) {
        link.href = `/collections/all?az_size=${encodeURIComponent(size)}`;
        return;
      }

      if (family && url.pathname.replace(/\/$/, '') !== '/collections/all') {
        link.href = catalogUrl(family);
      }
    });
  };

  rewriteProductSelectionLinks();
  document.addEventListener('shopify:section:load', (event) => {
    rewriteProductSelectionLinks(event.target);
  });

  if (!customElements.get('airzoe-size-menu')) {
    customElements.define(
      'airzoe-size-menu',
      class AirzoeSizeMenu extends HTMLElement {
        connectedCallback() {
          this.megaMenu = this.closest('.mega-menu--2');
          this.groups = Array.from(this.querySelectorAll('[data-airzoe-size-group]'));
          this.seriesLabel = this.querySelector('[data-airzoe-size-series]');
          this.placeholder = this.querySelector('[data-airzoe-size-placeholder]');
          this.closeTimer = null;
          this.activationTimer = null;
          this.activeTrigger = null;

          if (!this.megaMenu || this.groups.length === 0) return;

          this.triggers = Array.from(
            this.megaMenu.querySelectorAll('.mega-menu__link--level-2')
          ).filter((trigger) => this.findGroup(trigger.href));

          this.triggers.forEach((trigger) => {
            const family = familyFromUrl(trigger.href);
            if (family) trigger.href = catalogUrl(family);
            trigger.addEventListener('pointerenter', () => this.scheduleActivate(trigger));
            trigger.addEventListener('pointerleave', () => this.cancelActivation());
            trigger.addEventListener('focus', () => this.activate(trigger));
          });

          this.megaMenu.addEventListener('pointerenter', () => this.cancelClose());
          this.megaMenu.addEventListener('pointerleave', () => this.scheduleReset());
          this.megaMenu.addEventListener('focusout', (event) => {
            if (!this.megaMenu.contains(event.relatedTarget)) this.scheduleReset();
          });
        }

        findGroup(url) {
          const family = familyFromUrl(url);
          return this.groups.find((group) => group.dataset.family === family);
        }

        scheduleActivate(trigger) {
          this.cancelActivation();
          if (trigger === this.activeTrigger) return;
          const delay = this.activeTrigger ? 380 : 100;
          this.activationTimer = window.setTimeout(() => this.activate(trigger), delay);
        }

        cancelActivation() {
          if (!this.activationTimer) return;
          window.clearTimeout(this.activationTimer);
          this.activationTimer = null;
        }

        activate(trigger) {
          const group = this.findGroup(trigger.href);
          if (!group) return;
          this.cancelActivation();
          this.cancelClose();
          this.activeTrigger = trigger;
          this.groups.forEach((item) => item.classList.toggle('is-active', item === group));
          this.triggers.forEach((item) =>
            item.classList.toggle('airzoe-size-menu__trigger-active', item === trigger)
          );
          this.seriesLabel.textContent = group.dataset.seriesTitle;
          this.placeholder.hidden = true;
        }

        scheduleReset() {
          this.cancelClose();
          this.closeTimer = window.setTimeout(() => this.reset(), 220);
        }

        cancelClose() {
          if (!this.closeTimer) return;
          window.clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }

        reset() {
          this.cancelActivation();
          this.activeTrigger = null;
          this.groups.forEach((group) => group.classList.remove('is-active'));
          this.triggers.forEach((trigger) =>
            trigger.classList.remove('airzoe-size-menu__trigger-active')
          );
          this.seriesLabel.textContent = 'Product series';
          this.placeholder.hidden = false;
        }
      }
    );
  }
})();
